import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid'
import FiltersSection from '../Filters/FiltersSection'
import withStyles from '@material-ui/core/styles/withStyles'
import connect from "react-redux/es/connect/connect";
import classNames from 'classnames';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {getEstatisticaEtapa, getOSContagemPorTipoPergunta} from "../../actions/orderActions";
import OSRespostasPieChart from "../../components/OSRespostasPieChart";
import MontagemKPI from "./MontagemKPIs";
import OSRespostasBarChart from "../../components/OSRespostasBarChart";
import Typography from "@material-ui/core/Typography";
import OSESeriesDHChart from "../../components/OSESeriesDHChart";

//const stations = [1,2,3,4]

const styles = theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
      marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
      marginBottom: theme.spacing(1) * 5,


    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
      paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
});

class Montagem extends Component {
    constructor(props) {
        super(props);


        // document.title = 'Montagem';

        this.renderContent = this.renderContent.bind(this);
        this.renderLoadingScreen = this.renderLoadingScreen.bind(this);
        this.onFilterClick = this.onFilterClick.bind(this);
    }

    componentDidMount(): void {
        this.props.getEstatisticaEtapa(20);
        this.props.getOSContagemPorTipoPergunta(201);
        this.props.getOSContagemPorTipoPergunta(202);
    }

    onFilterClick = () => {
        this.props.getEstatisticaEtapa(20);
        this.props.getOSContagemPorTipoPergunta(201);
        this.props.getOSContagemPorTipoPergunta(202);
    }

    componentDidUpdate(oldProps, oldState){
        // if (JSON.stringify(oldProps.filter) !== JSON.stringify(this.props.filter)) {
        //     this.props.getEstatisticaEtapa(20);
        //     this.props.getOSContagemPorTipoPergunta(201);
        //     this.props.getOSContagemPorTipoPergunta(202);
        // }
    }


    renderLoadingScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                <div align="center">
                    <CircularProgress className={classes.progress} />
                </div>
            </React.Fragment>
        )
    }

    renderContent(){
        const { classes } = this.props;
        const p201 = this.props.osContagemPorTipoPergunta.find(c => c.tipoPergunta === 201);
        const p202 = this.props.osContagemPorTipoPergunta.find(c => c.tipoPergunta === 202);

        return (<Grid container direction="column">
            <Grid container item direction="row" alignItems="stretch" spacing={16}>


                <Grid item xs={12} className={classes.marginBottom}>
                    <MontagemKPI isLoading={this.props.isLoading}  dados={this.props.montagem}  filter={this.props.filter} />
                </Grid>

                <Grid item xs={12} className={classes.marginBottom}>
                    <OSESeriesDHChart isLoading={this.props.isLoading} series={this.props.montagem.distribuicaoDataHora}
                                      filter={this.props.filter} title="RITMO POR HORA"/>
                </Grid>

                {p201 && p201.contagem.length > 0 &&
                    <Grid item xs={12} className={classes.marginBottom}>
                        <OSRespostasBarChart isLoading={this.props.isLoading} series={p201 ? p201.contagem : []}
                                             filter={this.props.filter} title="ENVELOPE"/>
                    </Grid>
                }

                {p202 && p202.contagem.length > 0 &&
                    <Grid item xs={12} className={classes.marginBottom}>
                        <OSRespostasBarChart isLoading={this.props.isLoading} series={p202 ? p202.contagem : []}
                                             filter={this.props.filter} title="INNERLOPE"/>
                    </Grid>
                }


                {/*<Grid item xs={6} className={classNames(classes.marginBottom, classes.marginRight)}>*/}
                {/*    <HourTotalByTypePerOperatorChart series={this.props.raspaCycleStatistics.hourUsageTotalsPerOperator} />*/}
                {/*</Grid>*/}


            </Grid>
        </Grid>)

    }

    //TODO: reactgridlayout https://github.com/STRML/react-grid-layout
    render() {
        const { classes, isLoading } = this.props;

        return (
            <React.Fragment>
                <Grid container direction="column" className={classes.dashboardSection}>
                    <Grid item xs={12}>
                        <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} onButtonClick={this.props.getRaspaCycleHourUsageStatistics}
                                        loading={this.props.loading} onFilterClick={this.onFilterClick} />
                    </Grid>
                </Grid>
                <Grid item  xs={12} sm={12} lg={12} xl={12}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        MONTAGEM
                    </Typography>
                </Grid>
                { isLoading ? this.renderLoadingScreen() : this.renderContent() }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        montagem: state.ordemServicoReducer.montagem,
        loading : state.ordemServicoReducer.isFetchingEstatisticaEtapa,
        filter: state.filter,
        osContagemPorTipoPergunta: state.ordemServicoReducer.osContagemPorTipoPergunta
    }
}


export default connect(mapStateToProps, {getEstatisticaEtapa, getOSContagemPorTipoPergunta} ) (withStyles(styles, {withTheme: true})(Montagem));
